var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M17,34C7.6,34,0,26.4,0,17S7.6,0,17,0c9.4,0,17,7.6,17,17S26.4,34,17,34z M17,1C8.2,1,1,8.2,1,17\r\n\t\tc0,8.8,7.2,16,16,16s16-7.2,16-16C33,8.2,25.8,1,17,1z"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M20.2,11.9c-0.4-0.1-0.8-0.2-1.1-0.2c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.3,0.6-0.3,1.2v0.7h2v2.5h-2v8.4h-3.2\r\n\t\tv-8.4h-1.5v-2.4l1.5-0.1v-0.6c0-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.4-1,0.7-1.3c0.3-0.4,0.7-0.7,1.3-0.9c0.5-0.2,1.1-0.3,1.9-0.3\r\n\t\tc0.5,0,0.9,0,1.2,0.1s0.7,0.2,0.9,0.3L20.2,11.9z"}))]);
}

Facebook.defaultProps = {"version":"1.1","width":"34px","height":"34px","x":"0px","y":"0px","viewBox":"0 0 34 34","style":{"enableBackground":"new 0 0 34 34"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
